import React, { Component } from "react";
import { FormControl, InputLabel, Select, TextField, MenuItem, Button } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import Http from "../../../Http";

export default class Recepcion extends Component {

  state = {
    pg_recep_fecha: null,
    transportistas: [],
    id_unidad_transporte: "",
    pg_destinos: 1
  }

  componentDidMount() {
    this.loadTransportistas();
    this.setState({ id_unidad_transporte: this.props.preguia.id_unidad_transporte })
  }

  loadTransportistas = async () => {
    let TRes = await Http.get('unidad-transporte/all');
    if (!TRes.error) {
      this.setState({ transportistas: TRes.data })
    }
  }

  render() {
    let { pg_recep_fecha, transportistas, id_unidad_transporte, pg_destinos } = this.state;
    transportistas = transportistas ? transportistas : []
    pg_recep_fecha = pg_recep_fecha ? pg_recep_fecha : new Date()
    return (
      <div>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel>Transportista</InputLabel>
            <Select
              value={id_unidad_transporte ? id_unidad_transporte : ""}
              onChange={(e) =>
                this.setState({ id_unidad_transporte: e.target.value })
              }
            >
              {transportistas.map((tra, i) => (
                <MenuItem key={i} value={tra.id}>
                  {tra.unidad} - {tra.transportista_nombre}{" "}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} disabled>
            <FormControl className="form-field" disabled>
              <KeyboardDateTimePicker
                disabled
                inputVariant="outlined"
                variant="inline"
                ampm={false}
                value={pg_recep_fecha}
                format="dd/MM/yyyy HH:mm"
                disablePast
                onChange={(e) => {
                  this.setState({ pg_recep_fecha: e });
                }}
              />
            </FormControl>
          </MuiPickersUtilsProvider>
        </div>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          <TextField
            fullWidth
            type="number"
            inputProps={{ min: 1 }}
            label="Número de destinos"
            variant="outlined"
            value={pg_destinos ? pg_destinos : 1}
            onChange={(e) => this.setState({ pg_destinos: e.target.value })}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
          <Button autoFocus onClick={() => { this.props.onConfirmarSucursal(this.state) }} color="primary">
            Confirmar
          </Button>
        </div>
      </div>
    );
  }
}
